<script>
import Chart from "chart.js";
import { Bar, mixins } from "vue-chartjs";
import "chartjs-plugin-annotation";

const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ["chartData", "hideXAxis"],
  mounted() {
    Chart.defaults.global.defaultFontFamily = "Roboto";
    Chart.defaults.global.defaultFontColor = "#333";

    this.options.scales.xAxes[0].ticks.display = !this.hideXAxis;

    this.renderChart(this.chartData, this.options);
  },
  data: () => ({
    listenerMounted: false,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      tooltips: {
        enabled: false
      },
      hover: {
        mode: "nearest",
        intersect: true
      },
      scales: {
        xAxes: [
          {
            display: true,
            type: "time",
            time: {
              unit: "hour",
              unitStepSize: 3
            },
            ticks: {
              display: true
            }
          }
        ],
        yAxes: [
          {
            id: "bg",
            type: "linear",
            position: "left",
            scaleLabel: {
              display: true,
              labelString: "BG (mmol/L)"
            },
            ticks: {
              max: 22,
              min: 0,
              stepSize: 11
            }
          },
          {
            id: "insulin",
            type: "linear",
            position: "right",
            scaleLabel: {
              display: true,
              labelString: "Insulin (U)"
            },
            ticks: {
              max: 44,
              min: 0,
              stepSize: 11
            }
          }
        ]
      },
      annotation: {
        annotations: [
          {
            type: "box",
            yScaleID: "bg",
            yMax: 10,
            yMin: 3.9,
            borderWidth: 1,
            borderColor: "rgba(0,0,0,0)",
            backgroundColor: "rgba(48, 76, 156, 0.15)"
          }
        ],
        drawTime: "afterDraw"
      }
    }
  })
};
</script>
